"use strict";
/**
 * Image Processing Check API Response Types
 *
 * Response types for image processing status endpoints.
 *
 * Backend handlers:
 * - lambda-main/src/routes/image-processing-check.ts → checkImageProcessing
 * - lambda-main/src/routes/image-processing-check.ts → getFailedProcessing
 *
 * No frontend fetcher — these are internal/admin endpoints.
 */
Object.defineProperty(exports, "__esModule", { value: true });
